import { Component, OnInit } from '@angular/core';
import { APIService } from '../../api.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-bank-reconciliation-print',
  templateUrl: './bank-reconciliation-print.component.html',
  styleUrls: ['./bank-reconciliation-print.component.scss']
})
export class BankReconciliationPrintComponent implements OnInit {

  jarvisData: any = [];
  agencyData: any = [];
  bankBalance: number = 0;
  tempdata = [];
  bankList: any;
  bankLedgerID: number = 0;
  bankName: string = "";
  lastMonth: any = new Date(new Date().getFullYear(), new Date().getMonth() + 0, 1);
  startDate: any = new FormControl(new Date(this.lastMonth));
  endDate: any = new FormControl(new Date());

  constructor(private appService: DataService, private commonFun: CommonService, private apiService: APIService, private commonService: CommonService) { }



  FDT: any;
  TDT: any;
  ledgerID: any;
  AgencyName: string = ''
  City: string = '';
  State: string = '';
  
  ngOnInit(): void {
    this.ledgerID = this.commonFun.GetParam("LID");
    this.FDT = this.commonFun.GetParam("FDT");
    this.TDT = this.commonFun.GetParam("TDT");
    this.bankName = decodeURIComponent(this.commonFun.GetParam("BankName") + "");

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      this.AgencyName = this.agencyData[0].AgencyName;
      this.City = this.agencyData[0].City;
      this.State = this.agencyData[0].State;
    }

    let bankList: any = this.apiService.getCookie("ERP_Cfg");
    if (bankList) {
      bankList = JSON.parse(bankList)[0].BankLedgers;
      if (bankList) {
        this.bankList = JSON.parse(bankList);
      }
    }

    this.getAPIData();
  }
  //API Call
  getAPIData() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let tmpData = [{
      ledgerID: this.commonService.GetParam('LID'),
      fromDT: this.commonService.GetParam('FDT'),
      toDT: this.commonService.GetParam('TDT'),
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'bankRecon',
      moduleID: 9,
      data: JSON.stringify(tmpData)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
  }

  // Print Data
  printReconciliationData() {
    setTimeout(function () {
      var printArea = $('#Reconciliation').html();
      $('body').html(printArea);
      window.print();
    });
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }
  //successResp - success  get handler
  successResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let tmpArry :any = [];
          let data = reponseData;
          data.Table1.forEach(function (item: any) {
            if(item.VoucherID != 0){
              tmpArry.push(item);
            }
        })
        this.tempdata = tmpArry;
          this.printReconciliationData();
        }
      }
    }
  }
}

